import * as Modal from 'redux/modal/modalActions';
import makeDialog from 'common/utils/makeDialog';

const useCreateAndAddMasterDialog = makeDialog(
  Modal.ModalConfigActionTypes.CREATE_COLL_AND_ADD_MASTER
);

export default useCreateAndAddMasterDialog;
